"use strict";

const WqMonitoringGeoServerLayerPopup = function () {
  var getPopupHtml = function (properties) {
    const { assetType } = getAssetIdentity(properties);

    if (assetType === "samplingSite") {
      return SamplingSitePopup.getPopupHtml(properties);
    } else if (assetType === "outfall") {
      return OutfallPopup.getPopupHtml(properties);
    }
  };

  var onPopupOpen = async function (properties, event = null) {
    const { assetType, id } = getAssetIdentity(properties);
    const rawProperties = { ...properties, id };
    const isWqMonitoringLocationLayer = true;

    if (assetType === "samplingSite") {
      return SamplingSitePopup.onPopupOpen(rawProperties, event, isWqMonitoringLocationLayer);
    } else if (assetType === "outfall") {
      return OutfallPopup.onPopupOpen(rawProperties, "outfalls", isWqMonitoringLocationLayer);
    }
  };

  // Front-end layer data carries the composite id; raw GeoServer rows carry asset_type + the raw id.
  var getAssetIdentity = function (properties) {
    return properties.asset_type
      ? { assetType: properties.asset_type, id: properties.id }
      : CompositeAssetId.parse(properties.id);
  };

  return {
    getPopupHtml,
    onPopupOpen,
  };
};

module.exports = WqMonitoringGeoServerLayerPopup();

const CompositeAssetId = require("../general/compositeAssetId");
const SamplingSitePopup = require("./samplingSitePopup");
const OutfallPopup = require("../outfalls/outfallPopup");
